import { useMemo } from 'react';
import ms from 'ms';
import moment from 'moment';
import _ from 'lodash';
import * as blueprint from '@adc/blueprint';
import useCountdown from '../../../../hooks/useCountdown';
export const useCounterOfferCountdown = (counterOffer) => {
    if (!counterOffer)
        return -1;
    const currentServerTime = blueprint.bidding.hooks.useMomentCurrentTime();
    const endTime = useMemo(() => {
        const expirationDate = _.get(counterOffer?.terms, 'expiration_date');
        if (!moment(expirationDate).isValid())
            return currentServerTime;
        return moment(expirationDate);
    }, [counterOffer, currentServerTime]);
    const { secondsRemaining } = useCountdown({
        currentServerTime,
        endTime,
        updateInterval: ms('500ms'),
    });
    return secondsRemaining;
};
//# sourceMappingURL=utils.js.map